import { Action } from '@ngrx/store';

export class RequestStatusAction implements Action {
  constructor(
    public type: string,
    public error?: Error,
  ) {}
}

export interface RequestStatus {
  readonly isLoaded: boolean;
  readonly isError: boolean;
  readonly error: Error | null;
}
